require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-can-shopify-support-multi-currency.json") })
        }
      }, "path---blog-can-shopify-support-multi-currency");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-can-shopify-support-multi-currency!./.cache/json/blog-can-shopify-support-multi-currency.json
// module id = 429
// module chunks = 231608221292675